import { Link } from 'react-router-dom';
interface RequestAccessButtonProps {
  label?: string;
  size?: 'md' | 'lg';
}
export function RequestAccessButton({
  label = 'Request Access',
  size = 'md',
}: RequestAccessButtonProps) {
  return (
    <Link
      className={`wf-request__button${size === 'lg' ? ' wf-request__button--lg' : ''}`}
      to="/request-access"
    >
      {label}
    </Link>
  );
}
